
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import {mapActions, mapGetters, mapState} from 'vuex';
    import Patient from '@/types/Patient';
    import { PrintPatientenkarteiPayload } from '@/store/patient';
    import {SystemEinstellung, SystemEinstellungKey} from '@/types/Einstellung';

    @Component({
        computed: {
            ...mapState('globals', ['rules']),
            ...mapState('patient', ['dialogs', 'loaders', 'patientData']),
            ...mapState('authentication', ['impfstelle_id']),
            ...mapGetters('authentication', ['getSystemEinstellung']),
        },
        methods: {
            ...mapActions('patient', ['printPatientenkartei', 'exportPatientenkartei']),
        },
    })
    export default class PatientDruckDetail extends Vue {
        @Prop() title!: string;
        @Prop() visible!: boolean;

        public patientData!: Patient;
        public impfstelle_id!: number;
        public printPatientenkartei!: (payload: PrintPatientenkarteiPayload) => void;
        public getSystemEinstellung!: <T>(parameter: SystemEinstellungKey) => SystemEinstellung<T>;

        public druckOptionen = {
            stammdaten: true,
            kartei: true,
            plaene: true,
            plaene_aktuell: false,
            diagnosen: false,
            kartei_nur_impfungen: false,
            kartei_ausser_impfungen: false,
        };

        public get params(): { patnr: number; options: number; impfstelle_id: number } {
            const { stammdaten, kartei, plaene, diagnosen, kartei_nur_impfungen, kartei_ausser_impfungen, plaene_aktuell} = this.druckOptionen;

            enum DruckOptions {
                Stammdaten = 1 << 0,
                Kartei = 1 << 1,
                Plaene = 1 << 2,
                Diagnosen = 1 << 3,
                Kartei_nur_Impfungen = 1 << 4,
                Kartei_ausser_Impfungen = 1 << 5,
                Plaene_Aktuell = 1 << 6,
            }

            const options = (stammdaten ? DruckOptions.Stammdaten : 0) |
                (kartei ? DruckOptions.Kartei : 0) |
                (plaene ? DruckOptions.Plaene : 0) |
                (diagnosen ? DruckOptions.Diagnosen : 0) |
                (kartei_nur_impfungen ? DruckOptions.Kartei_nur_Impfungen : 0) |
                (kartei_ausser_impfungen ? DruckOptions.Kartei_ausser_Impfungen : 0) |
                (plaene_aktuell ? DruckOptions.Plaene_Aktuell : 0);

            const patnr = this.patientData.patnr as number;
            const impfstelle_id = this.impfstelle_id;

            return { patnr, options, impfstelle_id };
        }

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (visible) {
                this.druckOptionen = {
                    stammdaten: true,
                    kartei: true,
                    plaene: true,
                    plaene_aktuell: false,
                    diagnosen: false,
                    kartei_nur_impfungen: false,
                    kartei_ausser_impfungen: false
                };
            }
        }

        public onClickExportAsPdf(): void {
            this.printPatientenkartei({
                ...this.params,
                name: this.patientData.name,
                export: true,
            });
        }

        @Watch('druckOptionen.kartei')
        public onChangeDruckOptionsKartei() {
            if (this.druckOptionen.kartei) {
                this.druckOptionen.kartei_ausser_impfungen = false;
                this.druckOptionen.kartei_nur_impfungen = false;
            }
        }

        @Watch('druckOptionen.kartei_nur_impfungen')
        public onChangeDruckOptionsKarteiNurImpfungen() {
            if (this.druckOptionen.kartei_nur_impfungen) {
                this.druckOptionen.kartei = false;
                this.druckOptionen.kartei_ausser_impfungen = false;
            }
        }

        @Watch('druckOptionen.kartei_ausser_impfungen')
        public onChangeDruckOptionsKarteiAllesAusserImpfungen() {
            if (this.druckOptionen.kartei_ausser_impfungen) {
                this.druckOptionen.kartei = false;
                this.druckOptionen.kartei_nur_impfungen = false;
            }
        }

        /*        @Watch('druckOptionen.diagnosen')
        public onChangeDruckOptionsKarteiAllesAusserDiagnosen() {
            if (this.druckOptionen.diagnosen) {
                this.druckOptionen.kartei = false;
                this.druckOptionen.kartei_nur_impfungen = false;
                this.druckOptionen.kartei_ausser_impfungen = false;
            }
        }*/
    }
